module.exports = __webpack_public_path__ + "static/media/icon-shop.9d8c866b.svg";